import { render, staticRenderFns } from "./OrderReturn.vue?vue&type=template&id=00ed46ef&"
import script from "./OrderReturn.vue?vue&type=script&lang=js&"
export * from "./OrderReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrderReturn.vue"
export default component.exports